module.exports = __webpack_public_path__ + "static/media/dongmami_aboutus.3989b35.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dongmami_aboutus.webm
// module id = gHqP
// module chunks = 1